import * as React from "react";
import ModalHeader from "../primitive/modal/ModalHeader2.primitive";
import ModalFooter2 from "../primitive/modal/ModalFooter2.primitive";
import { Modal } from "react-bootstrap";
import MedgoSampleInputLanding from "../primitive/MedgoSampleInputLanding.primitive";

function ModalLandingPageRessources({
  etablissementName,
  name,
  fonction,
  email,
  onChange,
  show,
  onHide,
  nextPage,
  errorMessage,
  isLoading
}: {
  etablissementName: string;
  show: boolean;
  name: string;
  fonction: string;
  email: string;
  onChange: (value1: string, value2: string) => void;
  nextPage: () => void;

  onHide: (value: void) => void;
  errorMessage: string;
  isLoading: boolean;
}) {
  let headerModal = "Livre Blanc";

  return (
    <div>
      <Modal onHide={onHide} show={show} dialogClassName="modal-medgo is-landing">
        <ModalHeader label={headerModal} />

        <div className="padding-left-m padding-right-m">
          <div className="row">
            <div className="col-xs-12">
              <div className="hero">
                <MedgoSampleInputLanding
                  label="Nom complet"
                  placeholder="NOM Prénom"
                  onChange={newValue => onChange("name", newValue)}
                  value={name}
                />
              </div>
            </div>
            <div className="col-xs-12">
              <div className="hero">
                <MedgoSampleInputLanding
                  label="Établissement"
                  placeholder="Nom de l'établissement"
                  onChange={newValue => onChange("etablissementName", newValue)}
                  value={etablissementName}
                />
              </div>
            </div>

            <div className="col-xs-12">
              <div className="hero">
                <MedgoSampleInputLanding
                  label="Fonction"
                  placeholder="Fonction dans l'établissement"
                  onChange={newValue => onChange("fonction", newValue)}
                  value={fonction}
                />
              </div>
            </div>

            <div className="col-xs-12">
              <div className="hero">
                <MedgoSampleInputLanding
                  label="Adresse e-mail"
                  placeholder="nom@etablissement.com"
                  onChange={newValue => onChange("email", newValue)}
                  value={email}
                />
              </div>
            </div>
          </div>

          <ModalFooter2
            buttons={[
              {
                label: "TÉLECHARGER LE LIVRE BLANC",
                onClick: nextPage,
                isLoading: isLoading,
                errorMessage: errorMessage
              }
            ]}
          />
        </div>
      </Modal>
      <div className="row">
        <div className="col-xs-12" />
      </div>
    </div>
  );
}

module.exports = ModalLandingPageRessources;



// WEBPACK FOOTER //
// ./assets/react/views/Landing/ModalLandingPageRessources.view.tsx